import logo from 'assets/images/logos/griddy.svg'
import { PAYMENT_PROVIDERS } from 'config'

export const companyInfo = {
  name: 'Griddy',
  phone: '800-993-6207',
  termsLink: 'https://www.griddyx.com/legal/',
  privacyPolicyLink: 'https://www.griddy.com/privacy-policy',
  homepageLink: '',
  iosAppLink: 'https://itunes.apple.com/us/app/griddy/id1196099593?mt=8',
  androidAppLink:
    'https://play.app.goo.gl/?link=https://play.google.com/store/apps/details?id=com.app.griddy',
  faviconLink: 'https://www.customer.development.griddyx.com/favicon.ico',
  forgotPasswordLink:
    'https://www.customer.development.griddyx.com/forgot-password',
  chaseMerchantID: '441193',
  chaseSubscriberID: '100000000325',
  chasePaymentCssURL:
    'https://frontend-chasepaymenttech.s3.us-west-2.amazonaws.com/form.css',
  paymentProvider: PAYMENT_PROVIDERS.CHASE,
  EFLLink: 'https://www.griddyx.com/legal/',
  TOSYRACLink: 'https://www.griddyx.com/legal/',
  customerPortalLink: 'https://www.customer.development.griddyx.com',
  callingHours: '',
  customerPortalName: 'My Griddy Portal',
  footerCertificate: '',
  supportEmail: '',

  // general (NTX) enrollment
  thankYouLink: '',
  thankYouLinkCommunitySolar:'',
  thankYouLinkAgency:'',
  expiration_days: '10',
}

const primary = '#ed0874'
const secondary = '#031f2e'
const white = '#fff'
const base = '#022135'
const gray = '#d5dee5'
const error = '#dd2c00'
const neutral3 = '#9DB1C6'
const neutral2 = '#7D8D9E'

export const color = {
  background: '#f2f3f6',
  base: '#022135',
  primary,
  secondary,
  blue: '#00BCD4',
  gray,
  grayMedium: '#7D8D9E',
  grey: '#999999',
  green: '#7CA51B',
  greenPromo: '#8FAB36',
  error,
  gradient: `linear-gradient(90deg, ${primary}, #f47725)`,
  link: primary,
  neutral1: '#022135',
  neutral2,
  neutral3,
  neutral4: '#D5DEE5',
  neutral5: '#F2F3F6',
  white: '#fff',
  footerColor: '#001f2e',
  darkerPrimary: '#b9205e',
  transparent: '#ffffff00',
  containerBackground: '#fdfbf8',
  bannerColor: white,
  bannerTextColor: '#022135',
  progressBarColor: primary,
  progressBarBackground: 'transparent',
  buttonTextColor: '#fff',
  buttonColor: primary,
  slider: primary,
  dropdown: '#022135',
  textColor: base,
  ratePanel: secondary,
  rateText: primary,
  offerDetails: neutral3,
  offerShortDescription: neutral2,
}

export const assets = {}

export const logoConfig = {
  localPath: 'assets/images/logos/griddy.svg',
  url: '',
  width: '140px',
  height: '62px',
  useLocal: true,
  logo,
  progressBarImage: {
    custom: false,
  },
}

const baseFamily = "'Helvetica Neue', Helvetica, Arial, sans-serif"
const customFont = 'Girloy'

export const font = {
  extraBold: '800',
  semiBold: '600',
  medium: '500',
  normal: '400',
  baseFamily,
  customFont,
  customFamily: `${customFont}, ${baseFamily}`,
}

export const fontFace = `
@font-face {
  font-family: ${font.customFont};
  src:
    url('/fonts/gilroy/Gilroy-Regular.woff2') format('woff2'),
    url('/fonts/gilroy/Gilroy-Regular.woff') format('woff');
  font-weight: ${font.normal};
  font-style: normal;
}

@font-face {
  font-family: ${font.customFont};
  src:
    url('/fonts/gilroy/Gilroy-Medium.woff2') format('woff2'),
    url('/fonts/gilroy/Gilroy-Medium.woff') format('woff');
  font-weight: ${font.medium};
  font-style: normal;
}

@font-face {
  font-family: ${font.customFont};
  src:
    url('/fonts/gilroy/Gilroy-SemiBold.woff2') format('woff2'),
    url('/fonts/gilroy/Gilroy-SemiBold.woff') format('woff');
  font-weight: ${font.semiBold};
  font-style: normal;
}

@font-face {
  font-family: ${font.customFont};
  src:
    url('/fonts/gilroy/Gilroy-ExtraBold.woff2') format('woff2'),
    url('/fonts/gilroy/Gilroy-ExtraBold.woff') format('woff');
  font-weight: ${font.extraBold};
  font-style: normal;
}
`

export const features = {
  DISPLAY_REFERRAL_NAME: false,
  LOCALE_HEADER: true,
  CALL_HEADER: false,
  CALL_FOOTER: true,
  CALL_FOOTER_PHONE: true,
  CALL_FOOTER_EMAIL: true,
  REQUIRE_FULL_SOCIAL:
    process.env.REACT_APP_REQUIRE_FULL_SOCIAL === 'true' ? true : false,
  ENERGY_SLIDER_DEFAULT: '2',
}
